import React from "react";
import "./passwordRulesModal.css";
import CloseButtonV2 from "./CloseButtonV2";

const PasswordRulesModal = ({ toggleModal }) => {
  const specialChars = ["!", "@", "# ", "$", "%", "^", "&", "*"];

  return (
    <>
      <div className="password-rules-modal">
        <div className="password-rules-modal-upper">
          <h2>Regler för lösenord</h2>
          <CloseButtonV2 onClick={toggleModal} />
        </div>
        <p className="password-rules-modal-sub-title">Lösenordet måste innehålla </p>
        <ul className="password-rules-list">
          <li className="password-rules-item">
            <span className="checkmark-icon">&#10003;</span>
            <p className="password-rules-text">Minst 8 karaktärer</p>
          </li>
          <li className="password-rules-item">
            <span className="checkmark-icon">&#10003;</span>
            <p className="password-rules-text">Stor bokstav</p>
          </li>
          <li className="password-rules-item">
            <div className="password-rules-modal-char-container">
              <div className="special-char">
                <span className="checkmark-icon">&#10003;</span>
                <p className="password-rules-text">Någon av dessa specialtecken: </p>
              </div>
              <div className="char-container">
                {specialChars.map((c, index) => (
                  <p className="chars" key={index}>
                    {c}
                  </p>
                ))}
              </div>
            </div>
          </li>
        </ul>
        <p className="password-rules-modal-sub-title">Exempel på lösenord</p>
        <p className="password-example">Vakansa!@</p>
      </div>
    </>
  );
};

export default PasswordRulesModal;
